import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { AlertsComponent, AppVersionEqualDirective, AppVersionGreaterDirective, AppVersionLessThanDirective, I18NDirective,
	LoggedInDirective, PaginationComponent, PercentInputDirective, PrivilegeDirective, PrivilegeEnabledDirective, PrivilegeDisabledDirective,
	PrivilegeHiddenDirective, PrivilegeShowDirective, ROI18NDirective, ServerVersionGreaterDirective, ServerVersionEqualDirective,
	ServerVersionLessThanDirective,
} from './directives';

import { ConditionallyRequiredValidator, } from './validators';

import { YesNoModalComponent, YesNoCancelModalComponent, } from './components';
import { SharedProviderFactory } from './shared.providerFactory';
import { ArrayContainsPipe, FilterPipe, OrderByPipe, PropTestPipe, StripUsedValuesPipe, } from './filters';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule,
		HttpClientModule
	],
	exports: [
		AlertsComponent,
		AppVersionGreaterDirective,
		AppVersionEqualDirective,
		AppVersionLessThanDirective,
		ArrayContainsPipe,
		ConditionallyRequiredValidator,
		FilterPipe,
		I18NDirective,
		LoggedInDirective,
		OrderByPipe,
		PaginationComponent,
		PercentInputDirective,
		PrivilegeDirective,
		PrivilegeDisabledDirective,
		PrivilegeEnabledDirective,
		PrivilegeHiddenDirective,
		PrivilegeShowDirective,
		PropTestPipe,
		ROI18NDirective,
		ServerVersionGreaterDirective,
		ServerVersionEqualDirective,
		ServerVersionLessThanDirective,
		StripUsedValuesPipe,
		YesNoModalComponent,
		YesNoCancelModalComponent,
	],
	declarations: [
		AlertsComponent,
		AppVersionGreaterDirective,
		AppVersionEqualDirective,
		AppVersionLessThanDirective,
		ArrayContainsPipe,
		ConditionallyRequiredValidator,
		FilterPipe,
		I18NDirective,
		LoggedInDirective,
		OrderByPipe,
		PaginationComponent,
		PercentInputDirective,
		PrivilegeDirective,
		PrivilegeDisabledDirective,
		PrivilegeEnabledDirective,
		PrivilegeHiddenDirective,
		PrivilegeShowDirective,
		PropTestPipe,
		ROI18NDirective,
		ServerVersionGreaterDirective,
		ServerVersionEqualDirective,
		ServerVersionLessThanDirective,
		StripUsedValuesPipe,
		YesNoModalComponent,
		YesNoCancelModalComponent,
	],
	providers: []
})
export class SocratesSharedModule {
	static forRoot(): ModuleWithProviders<SocratesSharedModule> {
		return {
			ngModule: SocratesSharedModule,
			providers: SharedProviderFactory.marshallProviders(),
		};
	}
}
